import { Link } from "react-router-dom"
import { ImageLoader } from "../UI/ImageLoader"
import { Col, Row } from "react-bootstrap"
import { Clock } from "react-bootstrap-icons"
import { BuyButton, DateBtn } from "./AfishaSlider"

export const AfishaMobile = ({ items }: { items: any }) => {


    return (
        <>
            {items.map((item: any) =>
                <div className='position-relative mb-2 border-bottom pb-2' key={item.id}>
                    {items.length > 1 ?
                        <div style={{ maxWidth: '400px', inset: 0, margin: 'auto' }}>
                            <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                {/* <div style={{ minHeight: "60px" }} className='d-flex align-items-end'>
                                                <h4 className='afisha-event-title mb-0 d-none d-md-block'>{item.name}</h4>
                                                <h4 className='afisha-event-title mb-0 d-md-none'>{item.name}</h4>
                                            </div> */}
                                <div className='position-relative text-center'>
                                    <ImageLoader wide={false} viewBoxCustom={null} src={`https://leningradcenter.ru/api/shows/afisha-img/${item.id}`} name={item.name} mHeight={'100vh'} />
                                </div>
                                <div className='afisha-event-desc mt-0 mb-1 ms-1' style={{ fontSize: "0.75rem" }}>{item.description}</div>
                            </Link>
                            <div className='d-flex align-items-end'>
                                <h4 className='afisha-event-title mb-0 d-none d-md-block'>{item.name}</h4>
                                <h4 className='afisha-event-title mb-0 d-md-none'>{item.name}</h4>
                            </div>
                            <Row className='justify-content-lg-around mt-1 mb-1'>
                                <Col>
                                    <div
                                        className='text-center d-flex justify-content-center align-content-center gap-2'
                                        style={{
                                            borderRight: "1px solid",
                                            borderRightColor: "#764ba246",
                                            borderRightWidth: "1px",
                                            // lineHeight: 1.2
                                        }}
                                    >{item.ageCategory}+</div>
                                </Col>
                                <Col className='text-center flex-wrap d-flex justify-content-center align-content-center'>
                                    {item.showSchedules[0] &&
                                        <div
                                            className='text-center d-flex justify-content-center align-content-center gap-2 flex-fill'
                                            style={{
                                                // color: '#764ba2',
                                                borderRight: "1px solid",
                                                borderRightColor: "#764ba246",
                                                borderRightWidth: "1px",
                                                lineHeight: 1.2
                                            }}
                                        ><Clock /> {item.showSchedules[0].duration} мин</div>
                                    }
                                </Col>
                                <Col className='text-center flex-wrap d-flex justify-content-center align-content-center'>
                                    <div
                                        style={{
                                            lineHeight: 1.2
                                        }}
                                        className='text-center text-nowrap d-flex justify-content-center align-content-center gap-2 flex-fill'
                                    >
                                        <svg width={16} height={16}>
                                            <use xlinkHref='lc-logo.svg#stage'></use>
                                        </svg>
                                        Основная сцена</div>
                                </Col>
                            </Row>
                            <div className='mt-1 mt-1'>
                                {item.showSchedules.length > 0 && <>
                                    <p className="mb-0"
                                        style={{
                                            color: "#764ba2",
                                            // lineHeight: 0
                                        }}
                                    >Выберите дату</p>
                                    <Row className='mb-2'>
                                        {item.showSchedules.map((date: any) =>
                                            <Col xs={4}>
                                                <DateBtn schedule={date} />
                                            </Col>
                                        )}
                                    </Row>
                                </>}
                                <Row>
                                    <BuyButton item={item} />
                                </Row>
                            </div>
                        </div>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                        <div className='position-relative text-center'>
                                            <div className='d-md-none'>
                                                <ImageLoader wide={false} viewBoxCustom={null} src={`/api/shows/afisha-img/${item.id}`} name={item.name} mHeight={'60vh'} />
                                            </div>
                                            <div className='d-none d-md-block'>
                                                <ImageLoader src={`/api/shows/head-img/${item.id}`} viewBoxCustom={null} wide={true} name={item.name} mHeight={'70vh'} />
                                            </div>
                                        </div>
                                    </Link>
                                </Col>
                                <Col lg={4}>
                                    <Link to={`/about-project/show/${item.seoUrl}`} className='link-decor'>
                                        <h3 className='afisha-event-title mt-3 mb-0'>
                                            <strong>{item.name}</strong>
                                        </h3>
                                        <Row className='justify-content-lg-around mt-1 mb-1'>
                                            <Col>
                                                <div
                                                    className='text-center d-flex justify-content-center align-content-center gap-2'
                                                    style={{
                                                        borderRight: "1px solid",
                                                        borderRightColor: "#764ba246",
                                                        borderRightWidth: "1px",
                                                        // lineHeight: 1.2
                                                    }}
                                                >{item.ageCategory}+</div>
                                            </Col>
                                            <Col className='text-center flex-wrap d-flex justify-content-center align-content-center'>
                                                {item.showSchedules[0] &&
                                                    <div
                                                        className='text-center d-flex justify-content-center align-content-center gap-2 flex-fill'
                                                        style={{
                                                            // color: '#764ba2',
                                                            borderRight: "1px solid",
                                                            borderRightColor: "#764ba246",
                                                            borderRightWidth: "1px",
                                                            lineHeight: 1.2
                                                        }}
                                                    ><Clock /> {item.showSchedules[0].duration} мин</div>
                                                }
                                            </Col>
                                            <Col className='text-center flex-wrap d-flex justify-content-center align-content-center'>
                                                <div
                                                    style={{
                                                        lineHeight: 1.2
                                                    }}
                                                    className='text-center text-nowrap d-flex justify-content-center align-content-center gap-2 flex-fill'
                                                >
                                                    <svg width={16} height={16}>
                                                        <use xlinkHref='lc-logo.svg#stage'></use>
                                                    </svg>
                                                    Основная сцена</div>
                                            </Col>
                                        </Row>
                                        <div className='mt-1 mt-1'>
                                            {item.showSchedules.length > 0 && <>
                                                <p className="mb-0"
                                                    style={{
                                                        color: "#764ba2",
                                                        // lineHeight: 0
                                                    }}
                                                >Выберите дату</p>
                                                <Row className='mb-2'>
                                                    {item.showSchedules.map((date: any) =>
                                                        <Col xs={4}>
                                                            <DateBtn schedule={date} />
                                                        </Col>
                                                    )}
                                                </Row>
                                            </>}
                                            <Row>
                                                <BuyButton item={item} />
                                            </Row>
                                        </div>
                                    </Link>
                                </Col>
                            </Row>
                        </>
                    }
                </div>
            )}

        </>
    )
}